import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface IState {
  markers: string | null
}

interface IStore extends IState {
  handleChangeGlobalStore: (value: Partial<IState>) => void
}

// global store
export const useMarkersStore = create<IStore>()(
  devtools((set) => ({
    markers: null,
    handleChangeGlobalStore: (value) => set((state) => ({ ...state, ...value })),
  })),
)
